import StoreDetailsIcon from '../../../../images/icon-store-locator-details.svg';
import {
  buildRoute,
  getAddressFragment,
  getBrandFragment,
  getDistanceFragment,
  getImageFragment,
  getPhoneFragment,
  getSocialsFragment,
  getStoreTypeFragment,
  getTitleFragment,
  getTopFragment,
  getWebsiteFragment
} from './fragments';
import { t } from '../i18n';

export const getDetailsItemTemplate = (activeMarker, userCoordinates, followUsLabel, defaultStoreImage) => {
  const titleFragment = getTitleFragment(activeMarker);
  const imageFragment = getImageFragment(activeMarker, defaultStoreImage);
  const brandFragment = getBrandFragment(activeMarker);
  const addressFragment = getAddressFragment(activeMarker, 'one_line');
  const topFragment = getTopFragment(activeMarker);
  const storeTypeFragment = getStoreTypeFragment(activeMarker);
  const phoneFragment = getPhoneFragment(activeMarker);
  const websiteFragment = getWebsiteFragment(activeMarker);
  const socialsFragment = getSocialsFragment(activeMarker, followUsLabel);
  const distanceFragment = getDistanceFragment(activeMarker);

  const routeLink = buildRoute(activeMarker, userCoordinates);

  return `
    <div class="text-right margin-bottom-1">
      <button type="button" class="btn-close" data-close-details>
        <img src="${CMS.contextPath}/.resources/selleria-module/webresources/public/images/icons-20/close.svg" alt="">
      </button>
    </div>

    <div class="row columns margin-bottom-2">
      ${imageFragment}
    </div>

    <div class="row collapse">
      <div class="columns shrink">
        <img class="marker-icon" src="${StoreDetailsIcon}" alt="" width="35px" height="43px">
      </div>

      <div class="columns">
        <div class="row collapse align-middle margin-bottom-1">
          <div class="columns small-6">
            ${titleFragment}
          </div>
          <div class="columns small-4 text-right">
            ${topFragment}
          </div>
        </div>

        <div class="row collapse align-bottom margin-bottom-2">
          <div class="columns small-12 medium-8">
            ${brandFragment}
          </div>
          <div class="columns small-12 medium-4">
            ${storeTypeFragment}
          </div>
        </div>

        <div class="row collapse align-bottom margin-bottom-1">
          <div class="columns small-12 medium-10">
            ${addressFragment}
          </div>
          <div class="columns small-12 medium-2 text-right">
            ${distanceFragment}
          </div>
        </div>

        <div class="row collapse">
          <div class="columns small-12 medium-12 margin-bottom-1">
            <a href="${routeLink}" target="_blank" class="button">
              ${t('buildRoute')}
            </a>
          </div>
        </div>

        <div class="row collapse">
          <div class="columns small-12 medium-6">
            <div class="contact-wrapper">
              ${phoneFragment}
              ${websiteFragment}
            </div>
          </div>
          <div class="columns small-12 medium-6">
            ${socialsFragment}
          </div>
        </div>
      </div>
    </div>
  `;
};
